<template>
	<div class="pd-select" v-show="pickerShow">
		<div class="layer">
			<div class="pd-select-head">
				<h2>{{ pickTitle }}</h2>
				<a href="javascript:void(0);" v-on:click="onClose" class="close">取消</a>
				<a href="javascript:void(0);" v-on:click="onSure" class="sure">确定</a>
			</div>
			<div class="pd-select-body">
				<mt-picker ref="picker" :slots='slotData' value-key='name' @change='onPickerChange'></mt-picker>
			</div>
		</div>
	</div>
</template>

<script>
	import { Picker } from 'mint-ui'
	import { mapGetters } from 'vuex'
	export default {
		name: 'PeriodSelectBox',
		components: {
			'mt-picker': Picker
		},
		computed: {
			...mapGetters({
				prod_pkg: 'getSelectedPkg'
			})
		},
		data: () => ({
			'selectedItem': null,
			'pickTitle': '选择服务时长',
			'pickerShow': false,
			'slotData': []
		}),
		mounted () {
		},
		methods: {
			onPickerChange (picker, value) {
				console.log('pick: ', value)
				this.selectedItem = value[0]['value']
			},
			doShowPicker (flag) {
				this.pickerShow = flag
			},
			onClose () {
				this.pickerShow = false
			},
			onSure () {
				if (!this.selectedItem) {
					this.toast('请选择服务时长')
					return
				}
				this.pickerShow = false
				this.$emit('change', [this.selectedItem])
			},
			setSoltData () {
				console.log('sell_periods: ', this.prod_pkg)
				let items = []
				this.prod_pkg.sell_periods.forEach(function (sub) {
					let item = {'name': sub, 'value': sub}
					items.push(item)
				}, this)
				this.slotData = [{flex: 1, values: items, className: 'slot1', defaultIndex: 0}]
				let it = null
				let self = this
				it = window.setTimeout(function () {
					let setSlotValue = self.$refs.picker.setSlotValue
					setSlotValue(0, items[0])
					console.log('default price: ', items[0])
					self.onPickerChange(0, items)
					window.clearTimeout(it)
				}, 100)
			},
			showPicker () {
				console.log(this.slotData)
				if (this.prod_pkg.sell_periods) {
					this.pickerShow = true
				}
			}
		}
	}
</script>

<style scoped="">
	.pd-select {
		display: flex;
	}
</style>



// WEBPACK FOOTER //
// PeriodSelectBox.vue?54260cd6